// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-select-filter ion-list {
  padding: 0 !important;
}
wm-select-filter .chip-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: stretch;
  overflow: auto;
  max-height: 600px;
}
wm-select-filter .chip-list ion-chip {
  order: 0;
  flex: 1 1 auto;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
wm-select-filter .chip-list ion-chip ion-label {
  order: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
wm-select-filter .chip-list ion-chip ion-icon,
wm-select-filter .chip-list ion-chip i {
  order: 0;
  flex: 0 1 auto;
  align-self: stretch;
}
wm-select-filter .chip-list ion-chip img {
  position: relative;
  height: 25px;
  display: block;
  margin-left: -7px;
  margin-top: -4px;
}
wm-select-filter .chip-list ion-chip wm-icon {
  height: 100%;
}
wm-select-filter .chip-list ion-chip wm-icon svg {
  height: 100%;
}
wm-select-filter div[appBuildSvg] {
  display: flex;
  margin-right: 6px;
}
wm-select-filter div[appBuildSvg] svg {
  height: 100%;
}
wm-select-filter ion-chip {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/filters/select-filter/select-filter.component.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;AAAJ;AACI;EACE,QAAA;EACA,cAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAN;AAEM;EACE,QAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAR;AAEM;;EAEE,QAAA;EACA,cAAA;EACA,mBAAA;AAAR;AAEM;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAAR;AAEM;EACE,YAAA;AAAR;AACQ;EACE,YAAA;AACV;AAKE;EACE,aAAA;EACA,iBAAA;AAHJ;AAII;EACE,YAAA;AAFN;AAKE;EACE,WAAA;AAHJ","sourcesContent":["wm-select-filter {\n  ion-list {\n    padding: 0 !important;\n  }\n  .chip-list {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-content: stretch;\n    align-items: stretch;\n    overflow: auto;\n    max-height: 600px;\n    ion-chip {\n      order: 0;\n      flex: 1 1 auto;\n      align-self: stretch;\n\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      ion-label {\n        order: 0;\n        flex: 1 1 auto;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      ion-icon,\n      i {\n        order: 0;\n        flex: 0 1 auto;\n        align-self: stretch;\n      }\n      img {\n        position: relative;\n        height: 25px;\n        display: block;\n        margin-left: -7px;\n        margin-top: -4px;\n      }\n      wm-icon {\n        height: 100%;\n        svg {\n          height: 100%;\n        }\n      }\n    }\n  }\n  \n  div[appBuildSvg] {\n    display: flex;\n    margin-right: 6px;\n    svg {\n      height: 100%;\n    }\n  }\n  ion-chip {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
